import { render, staticRenderFns } from "./SoftwareSourceButtons.vue?vue&type=template&id=470ead4b&scoped=true&"
import script from "./SoftwareSourceButtons.vue?vue&type=script&lang=js&"
export * from "./SoftwareSourceButtons.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareSourceButtons.vue?vue&type=style&index=0&id=470ead4b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470ead4b",
  null
  
)

export default component.exports